const map = {
	"./filigran.png": 5833,
	"./header1024.png": 2303,
	"./loginbk1.png": 3526,
	"./logooskala0.png": 5723,
	"./scan.png": 6734,
	"./smartphone-frame-0.png": 483,
	"./smartphone-frame.png": 3140,
	"./tablet-frame.png": 1141,
	"./wave.png": 1338
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8070;